import { render } from "./ForbiddenWords.vue?vue&type=template&id=f8edf6f4&scoped=true"
import script from "./ForbiddenWords.vue?vue&type=script&lang=js"
export * from "./ForbiddenWords.vue?vue&type=script&lang=js"

import "./ForbiddenWords.vue?vue&type=style&index=0&id=f8edf6f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8edf6f4"]])

export default __exports__